function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0002 12.5V16.6667C10.0002 16.6667 12.5252 16.2084 13.3335 15C14.2335 13.65 13.3335 10.8334 13.3335 10.8334M10.0002 12.5C11.1641 12.0571 12.2808 11.4987 13.3335 10.8334M10.0002 12.5L7.50016 10M7.50016 10C7.94362 8.84957 8.502 7.74676 9.16683 6.70838C10.1378 5.15587 11.4898 3.87758 13.0943 2.99512C14.6988 2.11266 16.5024 1.65535 18.3335 1.66671C18.3335 3.93338 17.6835 7.91671 13.3335 10.8334M7.50016 10H3.3335C3.3335 10 3.79183 7.47504 5.00016 6.66671C6.35016 5.76671 9.16683 6.70838 9.16683 6.70838M3.75016 13.75C2.50016 14.8 2.0835 17.9167 2.0835 17.9167C2.0835 17.9167 5.20016 17.5 6.25016 16.25C6.84183 15.55 6.8335 14.475 6.17516 13.825C5.85125 13.5159 5.42457 13.3372 4.97702 13.3234C4.52946 13.3096 4.09256 13.4615 3.75016 13.75Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgBoost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.087a59e6.svg";
export { ForwardRef as ReactComponent };